export function getSensorReadingState({ loading, connectionTone, value }) {
  if (loading) return 'loading';
  if (connectionTone === 'offline' || value == null || !Number.isFinite(Number(value))) return 'unavailable';
  return 'available';
}

export function getSensorMetricState({
  loading,
  connectionTone,
  value,
  historyValues = [],
  zeroIsValid = false,
  waitingForReadings = false,
}) {
  const baseState = getSensorReadingState({ loading, connectionTone, value });
  if (baseState === 'unavailable' && connectionTone !== 'offline' && waitingForReadings && value == null) {
    return 'pending';
  }
  if (baseState !== 'available' || zeroIsValid || Number(value) !== 0) return baseState;

  const finiteHistory = historyValues.map(Number).filter(Number.isFinite);
  return finiteHistory.some(item => item !== 0) ? 'available' : 'unavailable';
}
